import * as __vanilla_filescope__ from '@vanilla-extract/css/fileScope';
__vanilla_filescope__.setFileScope("src/styles.css.ts", "@paypalcorp/pp-react-badge");
import { style } from '@vanilla-extract/css';
import { textStyles } from '@paypalcorp/pp-react-text';
import { tokens } from '@paypalcorp/pp-react-theme';
import { getColorFamilyVars } from '@paypalcorp/pp-react-utils';
const badgeMaxWidth = '18rem'; // 288px

const commonStylesBorder = {
  borderStyle: 'solid',
  borderColor: 'transparent'
};
const getBadgeColor = (fontColor, backgroundColor = null) => {
  const colors = {
    color: fontColor
  };
  if (backgroundColor) {
    colors['backgroundColor'] = backgroundColor;
  }
  return colors;
};
const base = style({
  maxWidth: badgeMaxWidth,
  overflow: 'hidden',
  wordBreak: 'break-word',
  textTransform: 'none',
  WebkitLineClamp: 2,
  display: '-webkit-inline-box',
  WebkitBoxOrient: 'vertical',
  height: 'auto'
}, 'badge-base');
export const sizeStyles = {
  large: style([textStyles.caption, base, {
    borderRadius: tokens.border.radius.md,
    borderTopWidth: tokens.space[100],
    borderBottomWidth: tokens.space[100],
    borderRightWidth: tokens.space[100],
    borderLeftWidth: tokens.space[100]
  }, commonStylesBorder], 'badge-base_large'),
  small: style([textStyles.tag, base, {
    borderRadius: tokens.border.radius.sm,
    borderTopWidth: tokens.space[25],
    borderBottomWidth: tokens.space[25],
    borderRightWidth: tokens.space[100],
    borderLeftWidth: tokens.space[100]
  }, commonStylesBorder], 'badge-base_small')
};
export const leftIcon = style({
  position: 'relative',
  paddingInlineStart: `calc(${tokens.size.icon.xs} + ${tokens.space[25]})` // 8px + icon + 2px
}, 'badge-left_icon');
export const icon = style({
  position: 'absolute',
  insetInline: '0 auto',
  insetBlock: `calc(${tokens.border.thickness.normal} * -1)`
}, 'badge-icon');
const iconBadgeStyles = style({
  width: tokens.size.circle.xs,
  height: tokens.size.circle.xs,
  padding: tokens.border.thickness.normal,
  border: `${tokens.border.thickness.emphasis} solid ${tokens.color.background.surface}`,
  borderRadius: '50%'
}, 'badge-icon_badge');
export const authorized = style([iconBadgeStyles, getBadgeColor(tokens.color.success.main, tokens.color.background.main)], 'badge-authorized');
export const inProgress = style([iconBadgeStyles, getBadgeColor(tokens.color.warning.alt, tokens.color.background.main)], 'badge-inprogress');
export const onHold = style([iconBadgeStyles, getBadgeColor(tokens.color.error.main, tokens.color.background.main)], 'badge-onhold');
export const favorite = style([iconBadgeStyles, getBadgeColor(tokens.color.specialty.main, tokens.color.background.main)], 'badge-favorite');
export const numeric = style([textStyles.fieldLabelSm, getBadgeColor(tokens.color.error.contrast, tokens.color.error.main), {
  padding: `0 ${tokens.space[50]}`,
  height: tokens.size.icon.xs,
  minWidth: tokens.size.icon.xs,
  outline: `${tokens.border.thickness.emphasis} solid ${tokens.color.background.surface}`,
  border: '0',
  borderRadius: `calc(${tokens.size.circle.xs}/2)`,
  lineHeight: tokens.typography.body.lineHeight,
  textAlign: 'center',
  selectors: {
    [`[dir='rtl'] &`]: {
      textAlign: 'center'
    }
  }
}], 'badge-numeric');
export const contrastColorStyles = {
  high: {
    feature: style([getBadgeColor(tokens.color.specialty.contrast, tokens.color.specialty.main), {
      vars: getColorFamilyVars(tokens, 'specialty')
    }], 'badge-high_contrast_feature'),
    success: style([getBadgeColor(tokens.color.success.contrast, tokens.color.success.main), {
      vars: getColorFamilyVars(tokens, 'success')
    }], 'badge-high_contrast_success'),
    warning: style([getBadgeColor(tokens.color.warning.contrast, tokens.color.warning.main), {
      vars: getColorFamilyVars(tokens, 'warning')
    }], 'badge-high_contrast_warning'),
    critical: style([getBadgeColor(tokens.color.error.contrast, tokens.color.error.main), {
      vars: getColorFamilyVars(tokens, 'error')
    }], 'badge-high_contrast_critical'),
    neutral: style([getBadgeColor(tokens.color.info.main, tokens.color.info.contrast), {
      vars: getColorFamilyVars(tokens, 'info')
    }], 'badge-high_contrast_neutral'),
    overlay: style([getBadgeColor(tokens.color.overlay.contrast, tokens.color.overlay.main), {
      backdropFilter: `blur(calc(${tokens.blur.interactive} / 2))`,
      vars: getColorFamilyVars(tokens, 'overlay')
    }], 'badge-high_contrast_overlay'),
    highlight: style([getBadgeColor(tokens.color.primary.contrast, tokens.color.primary.main), {
      vars: getColorFamilyVars(tokens, 'primary')
    }], 'badge-high_contrast_highlight')
  },
  low: {
    feature: style([getBadgeColor(tokens.color.specialty.medium.contrast, tokens.color.specialty.medium.main), {
      vars: getColorFamilyVars(tokens, 'specialty')
    }], 'badge-low_contrast_feature'),
    success: style([getBadgeColor(tokens.color.success.medium.contrast, tokens.color.success.medium.main), {
      vars: getColorFamilyVars(tokens, 'success')
    }], 'badge-low_contrast_success'),
    warning: style([getBadgeColor(tokens.color.warning.medium.contrast, tokens.color.warning.medium.main), {
      vars: getColorFamilyVars(tokens, 'warning')
    }], 'badge-low_contrast_warning'),
    critical: style([getBadgeColor(tokens.color.error.medium.contrast, tokens.color.error.medium.main), {
      vars: getColorFamilyVars(tokens, 'error')
    }], 'badge-low_contrast_critical'),
    neutral: style([getBadgeColor(tokens.color.info.contrast, tokens.color.info.main), {
      vars: getColorFamilyVars(tokens, 'info')
    }], 'badge-low_contrast_neutral'),
    overlay: style([getBadgeColor(tokens.color.overlayInverse.contrast, tokens.color.overlayInverse.main), {
      backdropFilter: `blur(calc(${tokens.blur.interactive} / 2))`,
      vars: getColorFamilyVars(tokens, 'overlay')
    }], 'badge-low_contrast_overlay'),
    highlight: style([getBadgeColor(tokens.color.tertiary.main, tokens.color.tertiary.contrast), {
      vars: getColorFamilyVars(tokens, 'tertiary')
    }], 'badge-low_contrast_highlight')
  }
};
__vanilla_filescope__.endFileScope();
